import isEmpty from 'lodash.isempty'

export const getMetafield = (ob, name) => {
  const res = ob.filter((item) =>
    Object.keys(item).some((key) => item[key].includes(name))
  )
  if (!isEmpty(res)) {
    return res[0].value
  }
}
